const useCasesPopup = () => {
    const page = document.querySelector('body.post-type-archive-use-case');
    if (!page) return
    
    const useCasesGroup = document.querySelector('.wp-block-group.use-cases');
    if ( !useCasesGroup ) return

    const dialog = document.querySelector('dialog.restricted-use-case-entrance')
    if ( !dialog ) return

    const dialogClose = dialog.querySelector('button.close');
    const dialogEnter = dialog.querySelector('button.enter');

    const handleUseCaseLinkClick = e => {
        const link = e.target.closest('a.use-case-link.restricted');
        if (!link) return
        e.preventDefault();
        dialogEnter.dataset.url = link.href;
        dialog.showModal();
    }

    useCasesGroup.addEventListener('click', handleUseCaseLinkClick );
    dialogClose.addEventListener('click', () => dialog.close() )
    dialogEnter.addEventListener('click', () => { window.location = dialogEnter.dataset.url } )
}

export default useCasesPopup;